module.exports = __webpack_public_path__ + "536d4035cc2f864d82db063047ff2a9d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/up-5.png
// module id = 3263
// module chunks = 0